import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import cx from 'classnames';
import { ModalClose } from './Close';
import css from './Modal.sass';
/**
 * A Modal component.
 *
 * Based on [react-modal](https://reactcommunity.org/react-modal/).
 */

var appElement =
/*#__PURE__*/
document.querySelector('.wrapper .content') ||
/*#__PURE__*/
document.querySelector('body');
ReactModal.setAppElement(appElement);

function Modal(props) {
  var children = props.children,
      closeTimeoutMS = props.closeTimeoutMS,
      contentLabel = props.contentLabel,
      isOpen = props.isOpen,
      onAfterOpen = props.onAfterOpen,
      onRequestClose = props.onRequestClose,
      overlayClassName = props.overlayClassName,
      role = props.role,
      shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick,
      width = props.width,
      valign = props.valign,
      className = props.className;
  return React.createElement(ReactModal, {
    closeTimeoutMS: closeTimeoutMS,
    contentLabel: contentLabel,
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onRequestClose: onRequestClose,
    overlayClassName: cx(css.overlay, valign && css["overlay-vertical-align-".concat(valign)], overlayClassName || css.overlayDefaultBackground),
    className: cx(css.content, width && css["width-".concat(width)], className),
    portalClassName: cx(css.portal),
    bodyOpenClassName: css.bodyOpen,
    role: role,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }, children);
}

Modal.displayName = 'Modal';
Modal.propTypes = {
  /**
   * Primary content.
   */
  children: PropTypes.node,

  /**
   * Modal class name
   */
  className: PropTypes.string,

  /**
   * Number indicating the milliseconds to wait before closing the modal.
   */
  closeTimeoutMS: PropTypes.number,

  /**
   * String indicating how the content container should be announced to screenreaders
   */
  contentLabel: PropTypes.string,

  /**
   * Boolean describing if the modal should be shown or not.
   */
  isOpen: PropTypes.bool,

  /**
   * Function that will be run after the modal has opened.
   */
  onAfterOpen: PropTypes.func,

  /**
   * Function that will be run when the modal is requested to be closed, prior to actually closing.
   */
  onRequestClose: PropTypes.func,

  /**
   * Custom overlay CSS class name
   */
  overlayClassName: PropTypes.string,

  /**
   * String indicating the role of the modal, allowing the 'dialog' role to be applied if desired.
   */
  role: PropTypes.string,

  /**
   * Boolean indicating if the overlay should close the modal
   */
  shouldCloseOnOverlayClick: PropTypes.bool,

  /**
   * Modal window width. Can be small, medium, full.
   */
  width: PropTypes.string,
  valign: PropTypes.string
};
Modal.defaultProps = {
  closeTimeoutMS: 0,
  contentLabel: '',
  isOpen: false,
  role: 'dialog',
  shouldCloseOnOverlayClick: true,
  width: 'm',
  valign: 'center'
};
Modal.Close = ModalClose;
export { Modal };